const validatePhoneNumber = (phoneNumber) => {
    if (phoneNumber.length === 0) {
        return 'Phone number is required.'
    }

    if (phoneNumber.length < 10) {
        return 'Phone number must be 10 digit long.'
    }
    return 'valid'
}

export default validatePhoneNumber
